import {FFmpegConfBase} from './ffmpeg-conf-base';

export class FFmpegConf extends FFmpegConfBase<string> {

}
